<template>
  <div class="chuKuZuoyeWarp">
    <div class="chuKuZuoyeWarp-body">
      <div ref="searchBox">
        <div class="detailsTitle">
          <h4>组名维护</h4>
        </div>
        <!-- 查询条件 -->
        <div class="inpBox">
          <el-form :inline="true" :model="formInline" class="demo-form-inline">
            <el-form-item label="组名：">
              <el-input  placeholder="" maxlength="100" v-model="formInline.type" size="mini"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="mini" @click="chaxun" btnCode='000P00LB001' v-if="btnFlg[0]">查询</el-button>
              <el-button type="primary" size="mini" @click="chongZhi()" btnCode='000P00LB002' v-if="btnFlg[1]">重置</el-button>
              <el-button type="primary" size="mini" @click="addBtn" btnCode='000P00LB003' v-if="btnFlg[2]">新增</el-button>
              <el-button type="primary" size="mini" @click="xiugaiBtn" btnCode='000P00LB004' v-if="btnFlg[3]">修改</el-button>
              <el-button type="primary" size="mini" @click="deleteBtn" btnCode='000P00LB005' v-if="btnFlg[4]">删除</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <!--表格-->
      <div class="chuKuZuoyeWarp-body-table" :style="{height:h}">
        <el-table
          border
          height="100%"
          size="mini"
          ref="tabref"
          :data="cangchuTableData"
          style="width:100%"
          class="elTab"
          highlight-current-row
          @row-click="dianjixuanzhong"
          :header-cell-style="{background:'#F5F5F5',color:'black'}"
        >
          <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="showName"
            label="组名"
            align="center"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="showName2"
            label="编码"
            align="center"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="createName"
            label="创建人"
            align="center"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="createTime"
            label="创建时间"
            align="center"
            :formatter="dateFormat"
          ></el-table-column>
          <el-table-column
            prop="updateFlg"
            label="是否可修改"
            align="center"
          >
          <template slot-scope="scope"><div>
            <span  type="text" size="small" v-if="scope.row.updateFlg == '1'">是</span>
            <span  type="text" size="small" v-if="scope.row.updateFlg == '0'">否</span>
          </div></template>
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="updateUser"
            label="操作"
            align="center"
            width="200"
          >
          <template slot-scope="scope"><div>
            <el-button  type="text" size="small" @click="seeClick(scope.row)">查看</el-button>
          </div></template>
          </el-table-column>
        </el-table>
      </div>
      <!--分页 style="text-align: right;"-->
      <div class="pags" >
        <el-pagination
          background
          @current-change="handleCurrentChangeA"
          :current-page="current"
          :page-size="pagesize"
          :page-sizes="[10, 20, 30, 40,50]"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChangeA"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <!--点击添加按钮弹出框-->
    <div class="addMarkBox">
      <el-dialog
        title="添加"
        :visible.sync="addMark"
        :close-on-click-modal="false"
        width="40%"
        center
      >
        <!--form表单-->
        <el-form
          :model="addFormData"
          :rules="rules"
          ref="addFormData"
          label-width="100px"
          class="demo-dynamic"
          style="width:350px;margin:30px auto;"
        >
          <el-form-item
            label="组名"
            prop="kehuName"
          >
            <el-input  placeholder="" maxlength="50" v-model="addFormData.kehuName" style="width:200px" size="mini"></el-input>
          </el-form-item>
          <el-form-item
            label="编码:"
            prop="numAdd"
          >
          <!--onkeyup="value=value.replace(/[^\d]/g,'')"-->
            <el-input
              v-model="addFormData.numAdd"
              style="width:200px"
              size="mini"
              maxlength="50"
            ></el-input>
          </el-form-item>
          <el-form-item label="是否可修改:" prop="isChange">
            <el-radio v-model="addFormData.isChange" label="1">是</el-radio>
            <el-radio v-model="addFormData.isChange" label="0">否</el-radio>
          </el-form-item>
        </el-form>
        <div style="width:158px;margin:15px auto;">
          <el-button type="primary" @click="addQueding('addFormData')" :loading="addLoad">确定</el-button>
          <el-button type="primary" @click="addQuXiao('addFormData')">取消</el-button>
        </div>
      </el-dialog>
    </div>
    <!--点击修改按钮弹出框-->
    <div class="addMarkBox">
      <el-dialog
        title="修改"
        :visible.sync="xiugaiMark"
        :close-on-click-modal="false"
        width="40%"
        center
      >
        <!--form表单-->
        <el-form
          :model="xiugaiFormData"
          :rules="rules2"
          ref="xiugaiFormData"
          label-width="100px"
          class="demo-dynamic"
          style="width:350px;margin:30px auto;"
        >
          <el-form-item
            label="组名"
            prop="kehuName"
          >
            <el-input  placeholder="" maxlength="50" v-model="xiugaiFormData.kehuName" style="width:200px" size="mini"></el-input>
          </el-form-item>
          <el-form-item
            label="编码:"
            prop="numAdd"
          >
            <el-input
              v-model="xiugaiFormData.numAdd"
              style="width:200px"
              size="mini"
              maxlength="50"
            ></el-input>
          </el-form-item>
          <el-form-item label="是否可修改:" prop="isChange">
            <el-radio v-model="xiugaiFormData.isChange" label="1">是</el-radio>
            <el-radio v-model="xiugaiFormData.isChange" label="0">否</el-radio>
          </el-form-item>
        </el-form>
        <div style="width:158px;margin:15px auto;">
          <el-button
            type="primary"
            @click="xiugaiQueding('xiugaiFormData')"
            :loading="xiugaiLoad"
          >确定</el-button>
          <el-button type="primary" @click="xiugaiQuXiao('xiugaiFormData')">取消</el-button>
        </div>
      </el-dialog>
    </div>
    <!--点击查看-->
    <el-dialog
        title="查看"
        :visible.sync="seeMark"
        :close-on-click-modal="false"
        width="900"
        center
      >
        <span>
          <div class="addinpBox">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <span>显示名称：</span>
                  <el-input  placeholder="" maxlength="100" v-model="seeName" size="mini" style="width:150px;"></el-input>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <el-button type="primary" size="mini" @click="seeSearchClick">查询</el-button>
                <el-button type="primary" size="mini" @click="seeChongZhi">重置</el-button>
                <el-table
                  :data="seeTableList"
                  ref="seeTableList"
                  border
                  bordersize="mini"
                  style="width:95%;margin-top:10px;margin-left:4%;margin-bottom:17px"
                  center
                  :header-cell-style="{background:'#F5F5F5',color:'black'}"
                  :header-row-style="{height:'35px'}"
                  :row-style="{height:'25px'}"
                  highlight-current-row>
                  <el-table-column  type="index" prop="" width="55" label="序号" align="center"></el-table-column>
                  <el-table-column prop="showName"    label="显示名称" align="center" width="120"></el-table-column>
                  <el-table-column prop="itemNo"   label="编号" align="center" width="120" ></el-table-column>
                  <el-table-column prop="orderBy" label="显示顺序"  align="center" ></el-table-column>
                  <el-table-column prop="remark"    label="备注" align="center" ></el-table-column>
                  <el-table-column prop="createName"    label="创建人" align="center" ></el-table-column>
                  <el-table-column prop="createTime" label="创建时间" align="center" :formatter="dateFormat"></el-table-column>
                </el-table>
                <!-- 分页 10,25,50,100-->
                 <div style="margin-left:28px;">
                  <el-pagination background
                    @size-change="handleSizeChange2"
                    @current-change="handleCurrentChange2"
                    :current-page="seePageNo"
                    :page-sizes="[10,25,50,100]"
                    :page-size="seePageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="seeTotal">
                  </el-pagination>
                </div>
        </div>
        </span>
        <div style="width:158px;margin:15px auto;">
          <el-button type="primary" @click="seeQuXiao">取消</el-button>
        </div>
      </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import { getBtn } from '@/utils/getButton'
import { 
  dictionarySearch, // 列表数据
  addGroupType,     // 新增
  updateGroupType,   // 修改
  deleteGroupType,    // 删除
  seeGroupType,     // 查看
} from "@/api/spu"
import DonMessage from '@/utils/message'

export default {
  name: 'RukuDan',
  data () {
    return {
      // 按钮
      btnFlg: [],
      btnIdArr: ["000P00LB001","000P00LB002","000P00LB003","000P00LB004","000P00LB005"],
      h: '500px',
      numAdd: 0,
      cangchuTableData: [],
      type: [],
      xuanzhongArr: [],
      //  添加-客户
      addFormData: {
        kehuName: '', //  组名
        numAdd: '', //  编号
        name: '', //  名称
        one: '', //  顺序
        isChange: '' //  是否可修改
      },
      //  添加-客户
      xiugaiFormData: {
        kehuName: '', //  组名
        numAdd: '', //  编号
        name: '', //  名称
        one: '', //  顺序
        isChange: '' //  是否可修改
      },
      kehuAddName: '',
      kehuAddnumAdd: '',
      rules:{
        kehuName:[
           { required: true, message: '请输入组名', trigger: 'blur' },
        ],
        numAdd:[
          { required: true, message: '请输入编号', trigger: 'blur' },
        ],
        isChange:[
          { required: true, message: '请选择是否可修改', trigger: 'change' },
        ]
      },
      rules2:{
        kehuName:[
           { required: true, message: '请输入组名', trigger: 'blur' },
        ],
        numAdd:[
          { required: true, message: '请输入编号', trigger: 'blur' },
        ],
        isChange:[
          { required: true, message: '请选择是否可修改', trigger: 'change' },
        ]
      },
      addMark: false,
      xiugaiMark: false,
      addLoad: false,
      xiugaiLoad: false,
      //  查询条件
      formInline: {
        kehuName: '',
        ruKuStartTime: '',
        ruKuEndTime: '',
        chuanhao: ''
      },
      pagesize: 20,
      current: 1,
      total: 0,
      // 查看
      seeMark:false,
      seeName:'',
      seeTableList:[],
      seePageNo:1,
      seePageSize:20,
      seeTotal:0,
      seeId:'',
      showName:'',
    };
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight //  头部搜索盒子高度
    let pH = document.documentElement.clientHeight //  浏览器高度
    this.h = pH - h - 100 + 'px'
  },
  methods: {
    //  点击选中需要修改的行
    dianjixuanzhong (row) {
      this.xuanzhongArr = []
      this.xuanzhongArr = row
      this.numAdd = 0
    },
    //  字典-查询客户
    getGroupNosS () {
      // getGroupNos({
      // })
      //   .then(res => {
      //     this.type = res
      //   })
      //   .catch(err => {
      //     DonMessage.error(err.message);
      //   })
    },

    //  主数据
    getDictionaryListS () {
      dictionarySearch({
        pageNo: this.current, //  页数
        pageSize: this.pagesize, //  条数
        showName: this.formInline.type, // 组名
        groupType:1
      })
        .then(res => {
          this.xuanzhongArr = []
          this.total = res.total
          this.cangchuTableData = res.list
        })
        .catch(err => {
          DonMessage.error(err.message);
        })
    },

    // 点击添加按钮
    addBtn () {
      this.addMark = true
      this.addFormData = {
        kehuName: "",
        numAdd: "",
        name: "",
        one: "",
        beizhu: ""
      }
      this.getGroupNosS() // 获取客户
    },
    // 点击修改按钮
    xiugaiBtn( ) {
      if (this.xuanzhongArr.length==0) {
          DonMessage.error("请选择要操作的信息")
      }else if(this.xuanzhongArr.updateFlg == '0'){
        DonMessage.error("只能修改可修改的数据！")
      }else{
        this.xiugaiMark = true
        // console.log(this.xuanzhongArr,'3333')
          this.xiugaiFormData.kehuName = this.xuanzhongArr.showName
          this.xiugaiFormData.numAdd = this.xuanzhongArr.showName2
          this.xiugaiFormData.isChange = this.xuanzhongArr.updateFlg
      }
      //  this.getGroupNosS(); // 获取客户
    },
    // 添加-确定
    addQueding (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.addMark = false
          addGroupType({
             id:'',
             showName:this.addFormData.kehuName,  // 组名
             showName2:this.addFormData.numAdd,  // 编号
             updateFlg:this.addFormData.isChange   // 是否编辑
          })
            .then(res => {
              DonMessage.success("操作成功!")
              this.addLoad = false
              this.getDictionaryListS()
            })
            .catch(err => {
              DonMessage.error(err.message);
              this.addLoad = false
            })
        } else {
          DonMessage.error("请维护完整信息再操作")
          //  this.$refs["from"].clearValidate() //  移除校验结果
          return false
        }
      })
    },
    //  点击添加弹出框取消按钮
    addQuXiao (formName) {
      this.$refs[formName].resetFields()
      //  this.addFormData={
      //    kehuName: "",
      //    chuanhao: "",
      //  },
      this.addMark = false
    },
    //  修改----
    xiugaiQueding (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.xiugaiMark = false
          this.addLoad = true
           updateGroupType({
             id:this.xuanzhongArr.id,
             showName:this.xiugaiFormData.kehuName,  // 组名
             showName2:this.xiugaiFormData.numAdd,  // 编号
             updateFlg:this.xiugaiFormData.isChange   // 是否编辑
            //  dictionaryId:this.xuanzhongArr.dictionaryId,//  字典表id
            //   itemNo:this.xiugaiFormData.numAdd,//  编号
            //   showName:this.xiugaiFormData.name,//  显示名称
            //   orderBy:this.xiugaiFormData.one,//  显示顺序
            //   remark:this.xiugaiFormData.beizhu,//  备注
            //   groupNo:this.xiugaiFormData.kehuName,//  组名

           })
             .then(res => {
               DonMessage.success("操作成功!")
               this.addLoad = false
               this.getDictionaryListS()
             })
             .catch(err => {
               DonMessage.error(err.message);
               this.addLoad = false
             })
        } else {
          DonMessage.error("请维护完整信息再操作")
          //  this.$refs["from"].clearValidate() //  移除校验结果
          return false
        }
      });
    },
    xiugaiQuXiao(formName) {
      this.$refs[formName].resetFields()
      //  this.addFormData={
      //    kehuName: "",
      //    chuanhao: "",
      //  },
      this.xiugaiMark = false
    },
    //  点击删除
    deleteBtn() {
      if (this.xuanzhongArr.length == 0) {
        DonMessage.error("请选择需要操作的信息")
      } else {
          this.$confirm("是否确定删除？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
            .then(() => {
              deleteGroupType({
                id:this.xuanzhongArr.id, //  字典表id
              })
                .then(res => {
                  DonMessage.success("操作成功!")
                  this.getDictionaryListS()
                })
                .catch(err => {
                  DonMessage.error(err.message);
                })
            })
            .catch(() => {})
      }
    },

    //  查询
    chaxun () {
      this.getDictionaryListS()
    },
    // 重置
    chongZhi () {
      this.formInline = {
        kehuName: '',
        ruKuStartTime: '',
        ruKuEndTime: '',
        chuanhao: ''
      }
      this.getDictionaryListS()
    },
    // 表格分页
    handleCurrentChangeA (val) {
      this.current = val
      this.getDictionaryListS()
    },
    handleSizeChangeA (val) {
      this.pagesize = val
      this.getDictionaryListS()
    },
    // 查看
    seeClick(row){
      this.seeMark = true
      this.seeId = row.showName2
      // this.showName = row.showName
      this.getSeeData()
    },
    getSeeData(){
      seeGroupType({
        pageNo:this.seePageNo,
        pageSize:this.seePageSize,
        groupNo:this.seeId,
        showName:this.seeName
      }).then(res =>{
        this.seeTableList = res.list
        this.seeTotal = res.total
      }).catch(err =>{
        DonMessage.error(err.message);
      })
    },
    seeChongZhi(){
      this.seeName = ''
      this.getSeeData()
    },
    // 表格分页
    handleCurrentChange2 (val) {
      this.seePageNo = val
      this.getSeeData()
    },
    handleSizeChange2 (val) {
      this.seePageSize = val
      this.getSeeData()
    },
    //查看-查询按钮
    seeSearchClick(){
      this.getSeeData()
    },
    // 查看取消
    seeQuXiao(){
      this.seeMark = false
    },
    // 时间格式化
    dateFormat: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
        t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      return (
        t.getFullYear() +
        '-' +
        month +
        '-' +
        date +
        ' ' +
        hour +
        ':' +
        minutes +
        ':' +
        seconds
      )
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/dictionaryManagement/groupNameMaintain')

    this.getDictionaryListS()
      this.getGroupNosS() // 获取客户
  }
}
/* eslint-disable */
</script>

<style lang="scss" scoped>
.inpBox {
  .el-form-item {
    margin-left: 10px;
    margin-bottom: 0px;
  }
}
.el-form-item {
  margin-left: 10px;
}
.huoQuanChangeWarp-body-title {
  width: 100%;
  height: 35px;
  border-bottom: 1px solid #ccc;
  padding: 5px;
  box-sizing: border-box;
  span {
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    color: #2f2f2f;
    display: inline;
    line-height: 30px;
    //  margin-left: 20px;
  }
}
.chuKuZuoyeWarp {
  width: 100%;
  position: relative;
  height: 100%;
  .pags {
    width: 100%;
    // text-align: center;
  }
  //  border: solid 1px blue;
  .chuKuZuoyeWarp-body {
    width: 100%;
    position: absolute;

    .chuKuZuoyeWarp-body-queryIpt {
      //  margin-top: 5px;
      width: 100%;

      //  border: solid 1px;
      display: flex;
      ul {
        flex: 1;
        flex-direction: column;
        display: flex;
        li {
          margin-top: 5px;
          list-style: none;
        }
      }
    }

    .chuKuZuoyeWarp-body-btn {
      margin-top: 5px;
    }
    .chuKuZuoyeWarp-body-table {
      margin-top: 5px;
    }
  }
  /deep/ .el-textarea .el-textarea__inner {
    resize: none;
  }
}
</style>
